import React from 'react';
import { Configuration } from './Configuration';

export const ConfigurationContext = React.createContext<Configuration>({} as Configuration);